import { render, staticRenderFns } from "./hzfxMarsModel.vue?vue&type=template&id=fada7e66&scoped=true"
import script from "./hzfxMarsModel.vue?vue&type=script&lang=js"
export * from "./hzfxMarsModel.vue?vue&type=script&lang=js"
import style0 from "./hzfxMarsModel.vue?vue&type=style&index=0&id=fada7e66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fada7e66",
  null
  
)

export default component.exports